import { Component, EventEmitter, Inject, OnInit } from "@angular/core";
import { UntypedFormControl } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { Toast } from "src/app/ui/components/toast/toast";
import { FeatureViews } from "src/app/ui/models/domains/features/custom-feature-views";
import { PageViews } from "src/app/ui/models/domains/features/custom-page-views";
import { PageableResult } from "src/app/ui/models/domains/paginator/pageable-result";
import { FileCluster } from "src/app/ui/models/domains/pbm/clusters/file-cluster";
import { ImportClusterResult } from "src/app/ui/models/domains/pbm/clusters/import-cluster-result";
import { FileExportProcessor } from "src/app/ui/models/domains/pbm/exports/file-export-processor";
import { FeatureViewService } from "src/app/ui/services/feature-view.service";
import { FileExportService } from "src/app/ui/services/file-export.service";
import { LoadingService } from "src/app/ui/services/loading.service";
import { ClustersService } from "src/app/ui/services/pbm/clusters.service";
import { environment } from "src/environments/environment";
import { ConfirmDialog } from "../../../shared/dialogs/confirm-dialog/confirm-dialog.component";
import { AddBatchExportOrderRequest } from "./add-batch-export-order-request";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatTabChangeEvent } from "@angular/material/tabs";

@Component({
  selector: "add-batch-product-dialog",
  templateUrl: "./add-batch-product-dialog.component.html",
  styleUrls: ["./add-batch-product-dialog.component.scss"],
})
export class AddBatchProductDialogComponent implements OnInit {
  public addBatchClusterProductDialogEvent = new EventEmitter();

  public clusterId: string;
  public filesInput: FileList;
  public fileName: string;
  public selectedTabIndex = 0;
  public fileCluster = new FileCluster();
  private fileExportProcessor: FileExportProcessor;
  public result: ImportClusterResult;
  public message: string;
  public fileLink = environment.clusterTemplateRegisterFileUploadLink;
  public searchType: UntypedFormControl;
  public companyPageableResult = new PageableResult();

  constructor(
    public dialogRef: MatDialogRef<ConfirmDialog>,
    public activatedRoute: ActivatedRoute,
    private featureViewService: FeatureViewService,
    private fileExportService: FileExportService,
    private clusterService: ClustersService,
    private loadingService: LoadingService,
    private toast: Toast,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.searchType = new UntypedFormControl(1);
    this.clusterId = data.clusterId;
    this.result = new ImportClusterResult();
    this.fileExportProcessor = new FileExportProcessor();
  }

  ngOnInit() {
    this.featureViewService.activeFeatureView(FeatureViews.SearchClusters, PageViews.ClustersManagementPageView);
    this.fileCluster.setClusterId(this.clusterId);
  }

  getFile(event) {
    const files = event.target.files;
    if (!FileCluster.isCsvExtension(files.item(0))) {
      this.toast.showWarningToast("Insira um arquivo .csv");
    } else {
      const file = files.item(0);
      this.filesInput = files;
      this.fileName = file.name;
      this.fileCluster.setFile(file);
    }
    event.target.value = null;
  }

  async uploadFile() {
    this.fileCluster.getClusterId();
    if (!!this.fileCluster.hasFile()) {
      const ref = this.loadingService.beginLoading();
      try {
        const importClusterResult = await this.clusterService.importCluster(this.fileCluster);
        this.result = importClusterResult;
        this.toast.showSuccessToast(importClusterResult.getMessageResult());
        this.selectedTabIndex = 1;
        this.addBatchClusterProductDialogEvent.emit();
      } catch (message) {
        this.message = message.getMessageResult();
        this.toast.showWarningToast(message.getMessageResult());
      } finally {
        this.filesInput = null;
        this.fileName = null;
        this.fileCluster.setFile(null);
        this.loadingService.finishLoading(ref);
      }
    } else {
      this.toast.showWarningToast("Insira um arquivo .csv válido");
    }
  }

  public getSelectedTabIndex(): number {
    return this.selectedTabIndex;
  }

  public hasExportKey(): boolean {
    return !!this.result.getExportKey();
  }

  async changeTab(tabIndex: MatTabChangeEvent) {
    const loadingRef = this.loadingService.beginLoading();
    if (tabIndex.index === 1) {
      this.message;
    }
    this.selectedTabIndex = tabIndex.index;
    loadingRef.closeLoading();
  }

  public async exportFile() {
    const ref = this.loadingService.beginLoading();
    const request = this.result.getExportKey();
    const orderRequest = new AddBatchExportOrderRequest(this.clusterService, this.toast, this.fileExportService, request);
    const result = await this.fileExportProcessor.processFileBySas(orderRequest, ref);

    this.hasExportKey();
  }

  public closeDialog(): void {
    this.dialogRef.close();
  }
}
